<template><!--    https://mengxiong10.github.io/vue2-datepicker/index.html -->
    <div
            class="VDateTimePicker"
    >
        <date-picker
                v-model="localDatesArray"
                :type="type"
                :range="rangeLocal"
                :shortcuts="localPresets"
                :disabled="disabled"
                :editable="false"
                :default-value="new Date()"
                :format="format"
                value-type="date"
                :placeholder="placeholder"
                :show-time-panel="false"
                :show-hour="isShowHour"
                :show-minute="isShowMinute"
                :show-second="isShowSecond"
                :disabled-date="disabledDate"
                :getClasses="getClasses"
                @close="close"
                @clear="clear"
                ref="datepicker"
        >
            <template
                    #sidebar
                    v-if="typeof dates === 'object' && 'utc' in dates"
            >
                <div class="VDateTimePicker-sidebar">
                    <div class="VDateTimePicker-sidebar__title">
                        Time:
                    </div>
                    <div class="VDateTimePicker-sidebar__content">
                        <VToggle
                                :checked="dates.utc"
                                :is-vertical-toggle="true"
                                @click="updateUtc"
                        ></VToggle>
                        Local
                        UTC
                    </div>
                </div>

            </template>

            <template #footer>
                <div
                        class="VDateTimePicker-footer"
                        v-if="!solo"
                >
                    <div class="VDateTimePicker-footer-selects">
                        <VSelect
                                :item="time.start"
                                show-property="hour"
                                :options="hourOptions"
                                @updateItem="changeTime($event,'start')"
                        >
                            <VButton>{{ time.start.hour }}</VButton>
                        </VSelect>
                        <span>:</span>
                        <VSelect
                                :item="time.start"
                                show-property="minute"
                                :options="minuteOptions"
                                @updateItem="changeTime($event,'start')"
                        >
                            <VButton>{{ time.start.minute }}</VButton>
                        </VSelect>
                    </div>
                    <div
                            class="VDateTimePicker-footer-selects"
                            v-if="time.end && (choosedPreset? choosedPreset.text !=='Since' : true)"
                    >
                        <VSelect
                                :item="time.end"
                                show-property="hour"
                                :options="hourOptions"
                                @updateItem="changeTime($event,'end')"
                        >
                            <VButton v-if="time.end.hour">{{ time.end.hour }}</VButton>
                        </VSelect>
                        <span>:</span>
                        <VSelect
                                :item="time.end"
                                show-property="minute"
                                :options="minuteOptions"
                                @updateItem="changeTime($event,'end')"
                        >
                            <VButton v-if="time.end.minute">{{ time.end.minute }}</VButton>
                        </VSelect>
                    </div>
                </div>
            </template>
        </date-picker>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import {
        getDataTimeRangePresets,
        getObjectFromArray,
        formatDate,
        getTimeWithoutDate,
        getDateWithoutTime,
    } from '@/helpers/dateTimeHelper';
    import hourOptions from './VDateTimePicker/hourOptions.json';
    import minuteOptions from './VDateTimePicker/minuteOptions.json';
    import {getSinceRange, getCustomRange} from '@/helpers/dateTimeHelper';
    import moment from 'moment/moment';

    export default {
        name: 'VDateTimePicker',
        model: {
            prop: 'dates',
            event: 'change',
        },
        components: {
            DatePicker,
        },
        props: {
            type: {
                type: String,
                default: 'datetime',
                validator: function (value) {
                    return ['date', 'datetime', 'year', 'month', 'time', 'week'].includes(value);
                },
            },
            placeholder: {
                type: String,
                default: 'Choose a date',
            },
            range: {
                type: Boolean,
                default: true,
            },
            solo: {
                type: Boolean,
                default: false,
            },
            dates: {
                type: [Object, Date, String],
                default: () => {
                },
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            presets: {
                type: Array,
                default: () => [],
            },
            isShowPresets: {
                type: Boolean,
                default: true,
            },
            format: {
                type: String,
                default: 'YYYY-MM-DD HH-mm-ss',
            },
            isShowHour: {
                type: Boolean,
                default: false,
            },
            isShowMinute: {
                type: Boolean,
                default: false,
            },
            isShowSecond: {
                type: Boolean,
                default: false,
            },
            isOpenAfterMount: {
                type: Boolean,
                default: false,
            },
            choosedPreset: {
                type: Object,
                default: () => {
                },
            },
            disabledDate: {
                type: [Function],
                default: () => {
                    return false;
                },
            },
        },
        data() {
            return {
                localDatesArray: [],
                localData: {},
                localPresets: [],
                time: {
                    start: {
                        hour: 0,
                        minute: 0,
                    },
                    end: {
                        hour: 23,
                        minute: 55,
                    },
                },
                rangeLocal: false,
                hourOptions,
                minuteOptions,
            };
        },
        watch: {
            range: {
                immediate: true,
                handler(newValue) {
                    this.rangeLocal = newValue;
                },
            },
            localDatesArray: {
                immediate: false,
                handler(arrayDates) {
                    this.updateLocalDateTime(arrayDates);
                },
            },
            choosedPreset: {
                immediate: true,
                handler() {
                    this.updatePresets();
                    this.updateDates();
                    this.updateCurrentPresetStyles();
                },
            },
            dates: {
                immediate: true,
                handler() {
                    this.updateDates();
                },
            },
            localData: {
                immediate: false,
                handler(value) {
                    this.$emit('updateChoosedDate', value);
                },
            },
        },
        created() {
            this.updatePresets();
        },
        mounted() {
            if (this.isOpenAfterMount) {
                this.openPopup();
            }
        },
        methods: {
            updateDates() {
                const objDates = this.dates;
                if (objDates) {
                    this.time = getTimeWithoutDate(objDates);
                    const presetName = this.choosedPreset && this.choosedPreset.text ? this.choosedPreset.text :
                        objDates.preset;
                    if ((presetName && presetName !== 'Custom Range') || this.solo) {
                        this.rangeLocal = false;
                    } else {
                        this.rangeLocal = true;
                    }
                    if (this.rangeLocal) {
                        this.localDatesArray = [new
                        Date(this.$moment(objDates.start, 'YYYY-MM-DD').format('YYYY-MM-DD')),
                            new Date(this.$moment(objDates.end, 'YYYY-MM-DD').format('YYYY-MM-DD'))];
                    } else {
                        this.localDatesArray = new Date(this.$moment(objDates.start, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                    }
                }
            },
            updateCurrentPresetStyles() {
                setTimeout(() => {
                    let elements = document.querySelectorAll('.mx-datepicker-sidebar button');
                    elements.forEach((element) => {
                        element.classList.remove('active');
                    });
                    let dateIndex = this.localPresets.length - 1;
                    if (this.choosedPreset?.text) {
                        dateIndex = this.localPresets.findIndex((preset) => preset.text === this.choosedPreset.text);
                    }
                    let activeElement = document.querySelector(`button[data-index='${dateIndex}']`);
                    if (activeElement) {
                        activeElement.classList.add('active');
                    }

                }, 4);
            },
            updatePresets() {
                if (this.isShowPresets) {
                    const offset = this.localDates && this.localDates.utc ? -1 * new Date().getTimezoneOffset() : 0;
                    const additionalFilters = [];
                    if (this.choosedPreset) {
                        additionalFilters.push(getSinceRange.call(this, offset));
                        additionalFilters.push(getCustomRange.call(this, this.dates));
                    }
                    this.localPresets = [...getDataTimeRangePresets.call(this), ...additionalFilters];
                }
            },
            shortcutClicked(presetName) {
                const preset = this.localPresets.find((preset) => preset.text === presetName);
                this.$emit('choosePreset', preset);
            },
            getClasses(date) {
                const classes = [];
                const dayDiff = this.$moment(date).startOf('day').diff(this.$moment(new Date()).startOf('day'), 'days');
                if (dayDiff > -11 && dayDiff <= 0) {
                    classes.push('last10');
                } else if (dayDiff > -18 && dayDiff <= -11) {
                    classes.push('last17');
                } else if (dayDiff > -25 && dayDiff <= -18) {
                    classes.push('last24');
                }
                if (!this.solo) {
                    classes.push('solo');
                }
                return classes;
            },
            updateLocalDateTime(arrayDates) {
                if (this.solo) {
                    const date = this.$moment(arrayDates).utc().format();
                    if (date !== 'Invalid date') {
                        this.$emit('changeSolo', date);
                    }
                } else if (arrayDates) {
                    let date = '';
                    if (this.rangeLocal) {
                        date = this.getTimeFromSelects(getObjectFromArray(arrayDates), this.dates.utc);
                    } else {
                        if (Array.isArray(arrayDates)) {
                            date = {
                                start:
                                    moment(arrayDates[0]).subtract(0, 'minutes').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                                end:
                                    null,
                            };
                        } else {
                            date = {
                                start:
                                    moment(arrayDates).subtract(0, 'minutes').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                                end:
                                    null,
                            };

                        }
                        if (this.dates.preset) {
                            date.preset = this.dates.preset;
                        }
                        if (this.choosedPreset && this.choosedPreset.text) {
                            date.preset = this.choosedPreset.text;
                        }
                    }
                    if (this.dates.utc) {
                        date.utc = this.dates.utc;
                    }
                    const time = getTimeWithoutDate(date);
                    if (typeof arrayDates === 'string' || (!this.checkIsAllowUpdateTime(getDateWithoutTime(date), time))) {
                        time.start.hour = '00';
                        time.start.minute = '00';
                        date.start =
                            this.$moment(date.start).set({hour: 0, minute: 0, second: 0, millisecond: 0}).format();
                        this.time = time;
                    }
                    this.localData = date;
                }
            },
            getTimeFromSelects(unformatedDates) {
                const dates = _.cloneDeep(unformatedDates);
                dates.start = formatDate(this.$moment(dates.start).set({
                    hour: this.time.start.hour,
                    minute: this.time.start.minute,
                    second: 0,
                }), this.dates.utc);
                dates.end = formatDate(this.$moment(dates.end).set({
                    hour: this.time.end.hour,
                    minute: this.time.end.minute,
                    second: 0,
                }), this.dates.utc);
                return dates;
            },
            changeTime(time, type) {
                const newTime = _.cloneDeep(this.time);
                Object.assign(newTime[type], time);
                if (this.checkIsAllowUpdateTime(getDateWithoutTime(getObjectFromArray(this.localDatesArray), this.dates.utc),
                    newTime)) {
                    this.time = _.cloneDeep(newTime);
                    this.updateLocalDateTime(this.localDatesArray);
                }
            },
            choosePreset(presetName, presetIndex) {
                this.localData = this.localPresets[presetIndex];
                this.$refs.datepicker.closePopup();
            },
            checkIsAllowUpdateTime(date, time) {
                return !this.checkIsSameDates(date) || this.checkIsSameDates(date) && this.checkIsEndAfterStart(time);
            },
            checkIsEndAfterStart(time) {
                return (+time.start.hour * 60) + +time.start.minute <= (+time.end.hour * 60) + +time.end.minute;
            },
            checkIsSameDates(dates) {
                return JSON.stringify(dates.start) ===
                    JSON.stringify(dates.end);
            },
            updateUtc() {
                this.$emit('updateUtc');
            },
            close() {
                if (this.localData.text) {
                    this.$emit('choosePreset', this.localData);
                } else {
                    this.$emit('change', this.localData);
                }
            },
            clear() {
                if (typeof this.dates === 'string') {
                    this.$emit('change', '');
                }
            },
            openPopup() {
                this.$refs.datepicker.openPopup();
                this.updateCurrentPresetStyles();
            },
        },
    };
</script>
<style
    lang="scss"
    scoped
>
  .VDateTimePicker {
    &-sidebar {
      width: 106px;
      position: absolute;
      bottom: 10px;
      color: $dark-blue-color;
      order: 1;
      display: flex;
      flex-direction: column;
      padding-left: 6px;

      &__title {
        font-weight: 700;
        font-size: 15px;
      }

      &__content {
        display: flex;
      }
    }

    &-footer {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;

      &-selects {
        display: flex;
        align-items: center;
      }
    }
  }
</style>
<style>
    .mx-datepicker-main {
        height: 395px;
        //height: auto;
    }

    .mx-range-wrapper, .mx-calendar {
        height: 285px;
    }

    .mx-datepicker-sidebar {
        width: 112px;
        padding-right: 0;

        .active {
            background-color: #6e94e9;
            color: white;
            pointer-events: none;
        }
    }

    .mx-datepicker-sidebar + .mx-datepicker-content {
        margin-left: 112px
    }

    .mx-datepicker-footer .VSelect-dropdown {
        max-height: 231px;
    }

    .last24 {
        color: #9c7396 !important;
    }

    .last17 {
        color: #a62576 !important;
    }

    .last10 {
        color: #ff1400 !important;
    }
</style>
